<template>
	<div>
		<header>
			<div class="top">
				<div class="address" @click="goToAddress">
					<img src="@/assets/images/index/point.png" alt="" class="point" />
					<div class="text">{{ memberSelectedAddress ? memberSelectedAddress.title || memberSelectedAddress.address_name || memberSelectedAddress.address : '' }}</div>
					<img src="@/assets/images/index/arrow_down_white.png" alt="" class="arrow" />
				</div>
			</div>
			<div class="search" @click="goToSearch"><img src="@/assets/images/index/search_icon.png" alt="" /></div>
			<div class="banner" v-if="broadcast.length > 0">
				<swiper :options="swiperOption" ref="mySwiper">
					<swiper-slide v-for="(banner, index) in broadcast" :key="index">
						<a :href="banner.link"><img :src="banner.pic" alt="" /></a>
					</swiper-slide>
					<div v-if="broadcast.length > 1" class="swiper-pagination pagination" slot="pagination"></div>
				</swiper>
			</div>
			<div class="date" @click="showPicker('personal')" v-if="$root.type == 'personal'">
				<img src="@/assets/images/index/time.png" alt="" class="time" />
				<div v-if="JSON.stringify(datetime) != '{}'" class="text">请选择自提时间：{{ datetime.date && datetime.date.slice(5) }}{{ `(${datetime.week})` }}</div>
				<div v-else class="text">请选择自提时间：暂无可选时间</div>
				<img src="@/assets/images/index/arrow_down_white.png" alt="" class="arrow" />
			</div>
			<div class="date" @click="showPicker('package')" v-if="$root.type == 'package' || this.level == 10">
				<img src="@/assets/images/index/time.png" alt="" class="time" />
				<div v-if="JSON.stringify(datetime) != '{}'" class="text">
					请选择配送时间：{{ datetime.date && datetime.date.slice(5) }}{{ `(${datetime.week})` }}{{ datetime.area }}
				</div>
				<div v-else class="text">请选择配送时间：暂无可选时间</div>
				<img src="@/assets/images/index/arrow_down_white.png" alt="" class="arrow" />
			</div>
		</header>
		<main-container><ShopListItem v-for="(store, index) in storeList" :store="store" :nearest="index == 0" :key="index" /></main-container>
		<go-to-top />
		<div class="unpay" v-if="showUnpay && unpay == 1" @click.stop="goToPayment">
			<img src="@/assets/images/close_white_border.png" alt="" @click.stop="showUnpay = false" />
			<div class="text">请在{{ close_order }}分钟内支付</div>
		</div>
		<Footer />
	</div>
</template>

<script>
import {
	MemberSelectedAddress,
	SelectedDateTime,
	InitDateTime,
	MessageBoxImageType
} from "@/constants/";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import MainContainer from "@/components/MainContainer";
import ShopListItem from "@/components/ShopListItem";
import Footer from "@/components/Footer";
import GoToTop from "@/components/GoToTop";
import $localStorage from "@/utils/localStorage.js";
import { shopList, getSendTime } from "@/interface/shop";
import { takeTimeList } from "@/interface/order";
import { weixin } from "@/utils/wxconfig";
import bdMap from "@/utils/bdMap";
import { xxUrlParams } from "@/utils/getUrlParam";
import add0 from "@/utils/add0";
export default {
	data() {
		return {
			swiperOption: {
				loop: true,
				autoplay: true,
				pagination: {
					el: ".pagination",
					type: "bullets",
					bulletClass: "bullet",
					bulletActiveClass: "bullet-active",
					//type: 'fraction',
					//type : 'progressbar',
					// type : 'custom',
					progressbarOpposite: true, //使进度条分页器与Swiper的direction参数相反
					bulletElement: "span", //设定分页器指示器（小点）的HTML标签。
					dynamicBullets: true, //动态分页器，当你的slide很多时，开启后，分页器小点的数量会部分隐藏。
					dynamicMainBullets: 2, //动态分页器的主指示点的数量
					hideOnClick: true, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
					clickable: true //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
				}
			},
			showUnpay: true,
			unpay: 0,
			uppay_order_id: 0,
			close_order: 0,
			page: 1,
			pageLast: false,
			// 初始化的时间
			initDateTime: {},
			// 初始化时间字段名的key
			dateKey: "package",
			broadcast: [],
			datetime: {},
			storeList: [],
			sendTime: [],
			dateIndex: 0,
			timeIndex: 0,
			memberSelectedAddress: $localStorage.get(MemberSelectedAddress),
			// 自提时间
			takeTime: [],
			takeDateIndex: 0,
			takeTimeIndex: 0,
			level: 0
		};
	},
	computed: {
		store_ids() {
			return this.storeList.map(v => v.id).join(",");
		},
		// 配送picker数据
		pickerDateTime() {
			let date = [],
				time = [];
			date = this.sendTime.reduce((pre, next, index) => {
				if (next.section) {
					pre.push({
						text: next.date + next.week,
						value: next.date + next.week,
						...next
					});
					time.push(
						next.section.map(v => {
							v.text = v.start + "-" + v.end;
							v.value = v.start + "-" + v.end;
							return v;
						})
					);
				}
				return pre;
			}, []);
			return {
				date,
				time
			};
		},
		// 自提picker数据
		pickerTakeDateTime() {
			let date = [],
				time = [];
			date = this.takeTime.reduce((pre, next, index) => {
				if (next.section) {
					pre.push({
						text: next.date + next.week,
						value: next.date + next.week,
						...next
					});
					time.push(next.section.map(v => ({ text: v, value: v })));
				}
				return pre;
			}, []);
			return {
				date,
				time
			};
		},
		// 选中的自提时间
		takeDatetime() {
			let obj = {
				date: "",
				area: ""
			};
			if (this.takeTime.length > 0) {
				obj = {
					date: this.pickerTakeDateTime.date[this.takeDateIndex].date,
					week: this.pickerTakeDateTime.date[this.takeDateIndex].week,
					area: this.pickerTakeDateTime.time[this.takeDateIndex][
						this.takeTimeIndex
					].text
				};
			}
			return obj;
		},
		dateTimeQuery() {
			let obj = {};
			if (this.datetime && this.datetime.area) {
				let time = this.datetime.area.split("-");
				obj = {
					date: this.datetime.date,
					start: time[0],
					end: time[1]
				};
			}
			return obj;
		}
	},
	watch: {
		// 配送日期
		dateIndex(value) {
			this.$picker.refillColumn(1, this.pickerDateTime.time[value]);
			this.$picker.scrollColumn(1, 0);
			// let obj = {
			// 	date: value.date,
			// 	week: value.week,
			// 	area: value.area
			// };
			// $localStorage.set(SelectedDateTime, obj);
			// this.initDateTime[this.dateKey] = obj;
			// $localStorage.set(InitDateTime, this.initDateTime);
		},
		// 自提日期
		takeDateIndex(value) {
			this.$picker.refillColumn(1, this.pickerTakeDateTime.time[value]);
			this.$picker.scrollColumn(1, 0);
		},
		datetime(value) {
			if (value && value.area) {
				value.area = value.area.replace(/ /g, "");
				let list = value.area.split("-");
				let obj = {
					date: value.date,
					start: list[0],
					end: list.length > 1 ? list[1] : "",
					week: value.week,
					area: value.area
				};
				$localStorage.set(SelectedDateTime, obj);
				this.initDateTime[this.dateKey] = obj;
				$localStorage.set(InitDateTime, this.initDateTime);
			}
		}
		// memberSelectedAddress(MemberSelectedAddress) {
		// 	$localStorage.set(MemberSelectedAddress);
		// }
	},
	mounted() {
		$localStorage.del("level");
		this.level = xxUrlParams.level;
		weixin.config();
		this.initDateTime = $localStorage.get(InitDateTime) || {};
    // 堂食或自取
		if (this.$root.type == "canteen" ) {
			this.dateKey = "canteen";
      let selfPick = this.$root.selfPick || 0;
      $localStorage.set("directSelfPick", selfPick);
		}
    else if (xxUrlParams.level == 10) {
			this.dateKey = "level";
			this.datetime = this.initDateTime[this.dateKey];
		} else if (this.$root.type == "personal") {
			this.dateKey = "personal";
			this.datetime =
				JSON.stringify(this.initDateTime) != "{}"
					? this.initDateTime[this.dateKey]
					: {};
		} else if (this.initDateTime[this.dateKey]) {
			this.datetime =
				JSON.stringify(this.initDateTime) != "{}"
					? this.initDateTime[this.dateKey]
					: {};
		}
		// 进入时判断是否有选中的地址
		let memberSelectedAddress = $localStorage.get(MemberSelectedAddress)
			? $localStorage.get(MemberSelectedAddress)
			: {};
		console.log(memberSelectedAddress);
		if (JSON.stringify(memberSelectedAddress) == "{}") {
			weixin.getLocation(res => {
				bdMap.getAddress(
					{
						longitude: res.lng,
						latitude: res.lat
					},
					data => {
						this.memberSelectedAddress = {
							address: data.address,
							title:
								data.surroundingPois.length > 0
									? data.surroundingPois[0].title
									: "",
							...res
						};
					}
				);
				this.getShopList(res);
			});
		} else {
			this.memberSelectedAddress = memberSelectedAddress;
			this.getShopList(memberSelectedAddress);
		}
	},
	methods: {
		goToAddress() {
			window.location.href = "./address.html?backurl=index";
		},
		goToSearch() {
			window.location.href = "./search.html";
		},
		getShopList(res) {
			let data = {
				lon: res.lng,
				lat: res.lat,
				user_id: this.$root.user_id,
				type: this.$root.type,
				page: 1,
				...this.dateTimeQuery
			};
			if (
				this.memberSelectedAddress &&
				this.memberSelectedAddress.building_id
			) {
				data.building_id = this.memberSelectedAddress.building_id;
			}
			if (xxUrlParams.level) {
				data.level = xxUrlParams.level;
			}
      let selfPick=xxUrlParams.selfPick || 0;
      data.selfPick = selfPick * 1;
      // console.info('xxUrlParams',xxUrlParams)
			shopList(data).then(data => {
				this.broadcast = data.result.broadcast;
				this.unpay = data.result.unpay;
				this.uppay_order_id = data.result.uppay_order_id || "";
				this.close_order = data.result.close_order;
				if (this.close_order <= 0) {
					this.unpay = 0;
				}
				if (this.broadcast.length <= 1) {
					this.swiperOption.loop = false;
					this.swiperOption.autoplay = false;
				}
				if (this.$root.type == "package" || this.$root.type == "personal") {
					this.datetime = data.result.datetime;
				} else {
					let now = new Date();
					let date = `${now.getFullYear()}-${add0(now.getMonth() + 1)}-${add0(
						now.getDate()
					)}`;
					let start = `${add0(now.getHours())}:${add0(now.getMinutes())}`;
					let end = `${add0(now.getHours())}:${add0(now.getMinutes())}`;
					let area = `${start}-${end}`;
					this.datetime = {
						date,
						start,
						end,
						area
					};
				}
				this.storeList = data.result.storeList;
				if (this.storeList.length == 0) {
					this.$msgbox.show({
						imageType: MessageBoxImageType.ImgAddressOverArea,
						messageText: "当前地址没有门店哦，请更换地址",
						confirmBtnText: "更换地址",
						showClose: true,
						confirmFn: () => {
							window.location.href = "address.html";
						}
					});
				} else {
					if (data.result.need_pop == 1) {
						this.$msgbox.show({
							messageText:
								"因系统升级，请重新输入送餐地址，为您带来不便深感抱歉。",
							confirmBtnText: "我知道了"
						});
					}
					if (this.$root.type == "personal") {
						this.takeTimeList();
					} else {
						this.getSendTime();
					}
				}
			});
		},
		// 获取自提时间列表
		takeTimeList() {
			let _this = this;
			let ischeckdate = false;
			let ischecktime = false;
			takeTimeList({ store_id: this.store_ids }).then(data => {
				this.takeTime = data.result;
				if (this.$picker.instance) {
					this.$picker.destroy();
				}
				let dateIndex = 0,
					timeIndex = 0;
				this.takeTime.some((dateObj, index) => {
					if (dateObj.date == this.datetime.date) {
						dateIndex = index;
						this.takeDateIndex = index;
						ischeckdate = true;
						dateObj.section.some((area, index2) => {
							if (area == this.datetime.area) {
								timeIndex = index2;
								this.takeTimeIndex = index2;
								ischecktime = true;
								return true;
							} else {
								return false;
							}
						});
						return true;
					} else {
						return false;
					}
				});
				// 自提
				this.$picker.init(
					{
						// data: [this.pickerTakeDateTime.date, this.pickerTakeDateTime.time[this.takeDateIndex]],
						// selectedIndex: [dateIndex, timeIndex]
						data: [this.pickerTakeDateTime.date],
						selectedIndex: [dateIndex, timeIndex]
					},
					{
						changeFn: (index, selectedIndex) => {
							if (index == 0) {
								this.takeDateIndex = selectedIndex;
							}
							if (index == 1) {
								this.takeTimeIndex = selectedIndex;
							}
						},
						selectFn: (selectedVal, selectedIndex) => {
							ischeckdate = true;
							[this.takeDateIndex, this.timeIndex] = selectedIndex;
							// this.takeDateIndex = selectedIndex;
							_this.datetime = {
								date: this.pickerTakeDateTime.date[this.takeDateIndex].date,
								week: this.pickerTakeDateTime.date[this.takeDateIndex].week,
								area: this.pickerTakeDateTime.time[this.takeDateIndex][
									this.timeIndex
								].text
							};
							this.getShopList({
								lng: this.memberSelectedAddress.lng,
								lat: this.memberSelectedAddress.lat
							});
						}
					}
				);
				let area = _this.takeTime[this.takeDateIndex].section[this.timeIndex];
				if (ischeckdate === false) {
					if (this.takeTime.length == 0) {
						this.datetime = {};
					} else {
						area =
							ischecktime === false
								? _this.takeTime[this.takeDateIndex].section[0]
								: _this.takeTime[this.takeDateIndex].section[this.timeIndex];
						this.datetime = {
							date: _this.takeTime[this.takeDateIndex].date,
							week: _this.takeTime[this.takeDateIndex].week,
							area: area
						};
					}
				} else if (ischecktime === false) {
					area = _this.takeTime[this.takeDateIndex].section[0];
					this.datetime = {
						date: _this.takeTime[this.takeDateIndex].date,
						week: _this.takeTime[this.takeDateIndex].week,
						area: _this.takeTime[this.takeDateIndex].section[0]
					};
				}
				if (ischeckdate === false && ischecktime === false) {
					let list = area.split("-");
					let obj = {
						date: this.datetime.date,
						start: list[0],
						end: list.length > 1 ? list[1] : "",
						week: this.datetime.week,
						area: area
					};

					$localStorage.set(SelectedDateTime, obj);
					this.initDateTime[this.dateKey] = obj;
					$localStorage.set(InitDateTime, this.initDateTime);
					if (this.$root.type != "canteen") {
						this.getShopList(this.memberSelectedAddress);
					}
				}
			});
		},
		getSendTime() {
			let params = {
				ids: this.store_ids
			};
			let _this = this;
			if (xxUrlParams.level == 10) {
				params.level = xxUrlParams.level;
				$localStorage.set("level", xxUrlParams.level);
			}
			let ischeckdate = false;
			let ischecktime = false;
			getSendTime(params).then(data => {
				this.sendTime = data.result.filter(v => v.section);
				let dateIndex = 0,
					timeIndex = 0;
				if (this.sendTime.length > 0) {
					this.sendTime.some((dateObj, index) => {
						if (dateObj.date == this.datetime.date) {
							dateIndex = index;
							this.dateIndex = index;
							ischeckdate = true;
							dateObj.section.some((area, index2) => {
								if (
									area.start == this.datetime.start &&
									area.end == this.datetime.end
								) {
									timeIndex = index2;
									this.timeIndex = index2;
									ischecktime = true;
									return true;
								} else {
									return false;
								}
							});
							return true;
						} else {
							return false;
						}
					});
				}
				if (this.$picker.instance) {
					this.$picker.destroy();
				}
				this.$picker.init(
					{
						data: [
							this.pickerDateTime.date,
							this.pickerDateTime.time[this.dateIndex]
						],
						selectedIndex: [dateIndex, timeIndex]
					},
					{
						changeFn: (index, selectedIndex) => {
							if (index == 0) {
								this.dateIndex = selectedIndex;
							}
							if (index == 1) {
								this.timeIndex = selectedIndex;
							}
						},
						selectFn: (selectedVal, selectedIndex) => {
							ischeckdate = true;
							[this.dateIndex, this.timeIndex] = selectedIndex;
							this.datetime = {
								date: this.pickerDateTime.date[this.dateIndex].date,
								week: this.pickerDateTime.date[this.dateIndex].week,
								area: this.pickerDateTime.time[this.dateIndex][this.timeIndex]
									.text
							};
							this.getShopList({
								lng: this.memberSelectedAddress.lng,
								lat: this.memberSelectedAddress.lat
							});
						}
					}
				);
				let area = _this.sendTime[this.dateIndex].section[this.timeIndex].text;
				if (ischeckdate === false) {
					if (this.sendTime.length == 0) {
						this.datetime = {};
					} else {
						area =
							ischecktime === false
								? _this.sendTime[this.dateIndex].section[0].text
								: _this.sendTime[this.dateIndex].section[this.timeIndex].text;
						this.datetime = {
							date: _this.sendTime[this.dateIndex].date,
							week: _this.sendTime[this.dateIndex].week,
							area: area
						};
					}
				} else if (ischecktime === false) {
					area = _this.sendTime[this.dateIndex].section[0].text;
					this.datetime = {
						date: _this.sendTime[this.dateIndex].date,
						week: _this.sendTime[this.dateIndex].week,
						area: _this.sendTime[this.dateIndex].section[0].text
					};
				}
				if (ischeckdate === false && ischecktime === false) {
					let list = area.split("-");
					let obj = {
						date: this.datetime.date,
						start: list[0],
						end: list[1],
						week: this.datetime.week,
						area: this.datetime.area
					};
					$localStorage.set(SelectedDateTime, obj);
					this.initDateTime[this.dateKey] = obj;
					$localStorage.set(InitDateTime, this.initDateTime);
					if (this.$root.type != "canteen") {
						this.getShopList(this.memberSelectedAddress);
					}
				}
			});
		},
		showPicker(type) {
			this.$picker.show();
		},
		goLink(link) {
			window.localStorage.href = link;
		},
		goToPayment() {
			window.location.href = `./payment.html?order_id=${this.uppay_order_id}`;
		}
	},
	components: {
		MainContainer,
		ShopListItem,
		GoToTop,
		Footer,
		swiper,
		swiperSlide
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
header {
	width: 100%;
	padding: 0 px2rem(20);
	background: {
		image: url("~@/assets/images/index/header_bg.png");
		repeat: no-repeat;
		position: top center;
		size: 100% auto;
	}
	.top {
		width: 100%;
		padding: px2rem(30) 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.address {
			display: flex;
			align-items: center;
			font-size: px2rem(26);
			color: #ffffff;
			img {
				display: block;
				&.point {
					width: px2rem(22);
				}
				&.arrow {
					width: px2rem(14);
				}
				&.time {
					width: px2rem(28);
				}
			}
			.text {
				margin: 0 px2rem(10);
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
	.date {
		display: flex;
		flex-direction: row;
		margin-top: px2rem(10);
		padding-right: px2rem(20);
		flex: 1;
		align-items: center;
		font-size: px2rem(26);
		color: #ffffff;
		height: px2rem(75);
		padding-left: px2rem(20);
		background: #f7cd0f;
		img {
			display: block;
			&.point {
				width: px2rem(22);
			}
			&.arrow {
				width: px2rem(14);
			}
			&.time {
				width: px2rem(28);
			}
		}
		.text {
			margin: 0 px2rem(10);
			justify-content: space-between;
			flex: 1;
		}
	}
	.search {
		height: px2rem(70);
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #ffffff;
		border-radius: px2rem(10);
		border: px2rem(1) solid #e4e4e4;
		padding: 0 px2rem(20);
		img {
			display: block;
			width: px2rem(26);
			margin-right: px2rem(20);
		}
		input {
			display: block;
			flex: 1 0 auto;
			font-size: px2rem(26);
			color: #a6a6a6;
		}
	}
	.banner {
		height: px2rem(260);
		width: 100%;
		margin-top: px2rem(20);
		border-radius: px2rem(10);
		overflow: hidden;
		img {
			width: 100%;
			height: 100%;
		}
		.pagination {
			@include square(100%, 20);
			bottom: px2rem(20);
			/deep/ .bullet {
				@include square(16);
				display: inline-block;
				margin: 0 px2rem(4);
				border-radius: 100%;
				border: px2rem(1) solid #fff;
				&.bullet-active {
					background-color: #fff;
				}
			}
		}
	}
}
.unpay {
	@include triangle(
		$arrow: right,
		$border: rgba(0, 0, 0, 0.7),
		$bg: transparent
	);
	@include pos-f($bottom: 270, $right: 20);
	@include dis-flex(center, center);
	background-color: rgba(0, 0, 0, 0.7);
	border-radius: px2rem(10);
	@include square(265, 60);
	img {
		display: block;
		@include square(40);
		margin-right: px2rem(10);
	}
	.text {
		white-space: nowrap;
		font-size: px2rem(22);
		font-weight: 300;
		color: #ffffff;
	}
}
</style>
